export const selectComponentWidth = 296;
export const contentWidth = 876;
